// @material-ui/icons

// core components/views for Admin layout

const anyRoutes = [];

export default anyRoutes;
